import m from 'mithril'
import FuzzyClock from '../fuzzy/fuzzy.js'
import "../shared/util.js"

document.addEventListener("DOMContentLoaded", function() {
  var root = document.getElementById("root")
  m.mount(root, FuzzyClock)
});